<body class="ltr main-body leftmenu">
    <form>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body pb-0">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <div class=" d-flex align-items-center pl-3">
                                                <!-- <img alt="Logo" src="../../assets/img/StateMaster.png"
                                                    class="mh-45px pb-2"> -->
                                                <div class="ml-2">
                                                    <h3 class="main-content-label mb-1"><b>
                                                          Student Attendance
                                                        </b></h3>
                                                    <p class="text-muted card-sub-title mb-0">
                                                     List Of Student Attendance
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-3" [formGroup]="StateSearchForm">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>{{'header.state-data.titleList.Search' | translate}}
                                                </mat-label> <input class="color" matInput placeholder="Search"
                                                    (keyup)="keypress()" formControlName="SearchString">
                                                <mat-icon matSuffix>search</mat-icon>
                                            </mat-form-field>
                                        </div> -->
                                        <div class="col-md-3"></div>
                                        <div class="col-md-1 prpl">
                                            <button id="addBtn" type="button"
                                                class="btn btn-primary btn-icon-text  mt-1"
                                                (click)="addnewrecord()">
                                                <span style="display: flex; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/plus.gif"
                                                        style="margin-right: 5px;">
                                                    New
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                    <hr class="mt-2">
                                    <div class="table-responsive table-container">
                                        <table  class="table table-bordered text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th class="f600">Id</th>
                                                    <th class="f600">RgNo</th>
                                                    <th class="f600">College Id</th>
                                                    <th class="f600">Attendance Percent</th>
                                                    <th class="f600">Attendance Id</th>
                                                    <th class="f600">Entry Time</th>
                                                    <th class="f600 text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr *ngFor="let attendancedata of attendanceList;">
                                                    <td> {{attendancedata.Id}}</td>
                                                    <td>{{attendancedata.RgNo}} </td>
                                                    <td>{{attendancedata.CgId}}</td>
                                                    <td>{{attendancedata.AtndPrcnt}} </td>
                                                    <td>{{attendancedata.AtndId}} </td>
                                                    <td>{{attendancedata.EntryTime}}</td>
                                                    <td class="text-center"> 
                                                        <a class="floating mr-2 pr-3" title="Edit"
                                                        (click)="editData(attendancedata)"> <i class="fa fa-edit "></i> </a>
                                                    <a class=" ml-2 floating" title="Delete"
                                                        (click)="deleteData(attendancedata)"> <i class="fas fa-trash"></i>
                                                    </a>
                                                </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <!-- <mat-paginator [length]="totalItems" [pageSize]="pageSize"
                                        [pageSizeOptions]="pageSizeOptions"
                                        (page)="onPageChange($event)"></mat-paginator> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>

